// Phases
export const PHASES = {
  FIELD_PREPARATION: 'field_preparation',
  SETUP: 'setup',
  SUPPLY: 'supply',
  CONSTRUCTION: 'construction',
  WAR: 'war',
};

// War phase stages
export const WAR_PHASE_STAGES = {
  RECRUITMENT: 'recruitment',
  MOVEMENT: 'movement',
  ABILITIES: 'abilities',
  SHOOTING: 'shooting',
  COMBAT: 'combat',
  MANEUVER: 'maneuver',
};

// Фазы, которые отыгрываются внутри раундов.
// Другие фазы, такие как FIELD_PREPARATION и SETUP отыгрываются только в начале игры.
export const ROUND_PHASES = [PHASES.SUPPLY, PHASES.CONSTRUCTION, PHASES.WAR];
